import { render } from "./ZaloPay.vue?vue&type=template&id=46b71697&scoped=true"
import script from "./ZaloPay.vue?vue&type=script&lang=js"
export * from "./ZaloPay.vue?vue&type=script&lang=js"

import "./ZaloPay.vue?vue&type=style&index=0&id=46b71697&scoped=true&lang=css"

import exportComponent from "/vercel/path0/my_res/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b71697"]])

export default __exports__